// API Configuration
// This file centralizes API endpoint configuration
// In production, the API_BASE will be automatically determined from the current domain

const getApiBase = () => {
  // In production, use relative URLs or the actual domain
  if (process.env.NODE_ENV === 'production') {
    // Use relative URL in production (same domain)
    return '/api';
  }
  // Development: use localhost
  return 'http://localhost:4000/api';
};

export const API_BASE = getApiBase();
export const API_BASE_FULL = process.env.NODE_ENV === 'production' 
  ? window.location.origin + '/api'
  : 'http://localhost:4000/api';

// Backend base URL (without /api)
export const BACKEND_BASE = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:4000';
